/* eslint-disable react/prop-types */
/* eslint-disable import/no-cycle */

import React from 'react';

import Input from '@ntuctech/devex-tangram/Input';
import ButtonContained from '@ntuctech/devex-tangram/Button/ButtonContained';

import { useAuth0 } from '../../Auth0Provider';
import FormWrapper from '../../theme/FormWrapper';
import FormElement from '../../theme/FormElement';
import FormActions from '../../theme/FormActions';

const fieldName = 'emailOrPhone';
const gaScreenName = 'SSO - Welcome';

const WelcomeForm = (props) => {
  const { trackPwl, setRedirectErrorShownCookie } = useAuth0();
  const {
    values,
    errors,
    handleChange,
    handleBlur,
    touched,
    isValid,
    dirty,
    isSubmitting,
    submitForm: submitformProp,
    initialValues,
    validateForm,
    needsReattempt,
    setNeedsReattempt,
  } = props;

  const submitForm = React.useCallback(
    (e) => {
      setRedirectErrorShownCookie();
      submitformProp(e);
    },
    [setRedirectErrorShownCookie, submitformProp],
  );

  const { emailOrPhone } = values;
  const { emailOrPhone: emailOrPhoneInitial } = initialValues;
  const [isAutofilled, setIsAutofilled] = React.useState(false);
  const [isInitiated, setIsInitiated] = React.useState(false);

  const showEmailOrPhoneError = touched[fieldName] && Boolean(errors[fieldName]);

  React.useEffect(() => {
    if (showEmailOrPhoneError && !needsReattempt) {
      trackPwl({
        screen_name: gaScreenName,
        event_action: 'Popup Show',
        event_label: 'Main_Email_Error_Invalid',
        origin_target: fieldName,
      });
      setNeedsReattempt(true);
    }
  }, [showEmailOrPhoneError, needsReattempt, setNeedsReattempt, trackPwl]);

  const isSubmitButtonDisabled = React.useMemo(() => {
    // making dirty to true if initial email is provided.
    const isDirty = emailOrPhoneInitial ? true : dirty;
    return (!isDirty || !isValid) && !isAutofilled;
  }, [dirty, isValid, emailOrPhoneInitial, isAutofilled]);

  React.useEffect(() => {
    // trigger form validation if initial email is provided.
    if (emailOrPhoneInitial) {
      validateForm();
    }
  }, [emailOrPhoneInitial, validateForm]);

  const handleKeyPress = React.useCallback(
    (event) => {
      if (event.key === 'Enter' && !isSubmitButtonDisabled) {
        event.target.blur();
        submitForm();
      }
    },
    [submitForm, isSubmitButtonDisabled],
  );

  const onAnimationStart = (e) => {
    if (e.bubbles && e.cancelable) {
      setIsAutofilled(true);
    }
  };

  const handleFocus = React.useCallback(() => {
    if (showEmailOrPhoneError) {
      trackPwl({
        screen_name: gaScreenName,
        event_action: 'Fill In',
        event_label: 'Main_Email_Error_Initiated',
        origin_target: fieldName,
      });
    } else if (!isInitiated) {
      trackPwl({
        screen_name: gaScreenName,
        event_action: 'Fill In',
        event_label: 'Main_Initiate',
        origin_target: fieldName,
      });
      setIsInitiated(true);
    }
  }, [showEmailOrPhoneError, isInitiated, trackPwl]);

  return (
    <FormWrapper hideLabel>
      <FormElement>
        <Input
          id="welcomeInputEmailOrPhone"
          data-testid="welcomeInputEmailOrPhone"
          type="text"
          name={fieldName}
          label="Email or mobile number"
          value={emailOrPhone}
          helpText={showEmailOrPhoneError ? errors[fieldName] : ''}
          error={showEmailOrPhoneError}
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyPress={handleKeyPress}
          onFocus={handleFocus}
          required
          fullWidth
          autoComplete="username"
          placeholder="Email or Mobile Number"
          onAnimationStart={onAnimationStart}
        />
      </FormElement>
      <FormElement hidden>
        <input
          id="welcomeInputHiddenPassword"
          data-testid="welcomeInputHiddenPassword"
          type="password"
          name="password"
          label="Password"
          autoComplete="current-password"
        />
      </FormElement>
      <FormActions>
        <ButtonContained
          fullWidth
          compact
          disabled={isSubmitButtonDisabled}
          loading={isSubmitting}
          onClick={submitForm}
          data-testid="welcomeButtonSubmit"
        >
          Next
        </ButtonContained>
      </FormActions>
    </FormWrapper>
  );
};

export default WelcomeForm;
